import React from 'react';
import { useUser } from '../contexts/UserContext';
import { AlertCircle } from 'lucide-react';
import { hasMenuPermission, isSuperAdmin } from '../utils/adminPermissions';

const ProtectedRoute = ({ children, requiredPath }) => {
  const { user, profile } = useUser();

  if (requiredPath === '/permissions') {
    if (!isSuperAdmin(user)) {
      return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
          <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">접근 권한 없음</h2>
          <p className="text-gray-600">이 페이지는 Super Admin만 접근할 수 있습니다.</p>
        </div>
      );
    }
    return children;
  }

  if (!hasMenuPermission(user, profile, requiredPath)) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">접근 권한 없음</h2>
        <p className="text-gray-600">이 페이지에 접근할 권한이 없습니다.</p>
        <p className="text-gray-500 text-sm mt-2">권한이 필요하시면 관리자에게 문의하세요.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
